export type AudienceMarkKind = 'community' | 'academy' | 'venue'

type MarkProps = {
  className?: string
}

const svg = {
  viewBox: '0 0 24 24',
  fill: 'none' as const,
  'aria-hidden': true,
}

function CommunityMark({ className = '' }: MarkProps) {
  return (
    <svg {...svg} className={className}>
      <circle
        cx="8.15"
        cy="13.35"
        r="3.55"
        fill="currentColor"
        fillOpacity="0.16"
        stroke="currentColor"
        strokeWidth="1.55"
      />
      <circle
        cx="15.85"
        cy="13.35"
        r="3.55"
        fill="currentColor"
        fillOpacity="0.16"
        stroke="currentColor"
        strokeWidth="1.55"
      />
      <circle
        cx="12"
        cy="8.2"
        r="3.7"
        fill="currentColor"
        fillOpacity="0.3"
        stroke="currentColor"
        strokeWidth="1.55"
      />
    </svg>
  )
}

function AcademyMark({ className = '' }: MarkProps) {
  return (
    <svg {...svg} className={className}>
      {/* Clipboard */}
      <rect
        x="6.25"
        y="5.4"
        width="11.5"
        height="14.2"
        rx="2.2"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="1.55"
      />
      <rect
        x="9.1"
        y="3.4"
        width="5.8"
        height="3.15"
        rx="1.2"
        fill="currentColor"
        fillOpacity="0.28"
        stroke="currentColor"
        strokeWidth="1.55"
      />
      {/* Rising progress */}
      <path
        d="M9.2 15.55v-1.7M12 15.55v-3.35M14.8 15.55V9.9"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  )
}

function VenueMark({ className = '' }: MarkProps) {
  return (
    <svg {...svg} className={className}>
      {/* Court */}
      <rect
        x="3.4"
        y="5.2"
        width="17.2"
        height="13.6"
        rx="2.1"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="1.55"
      />
      <path
        d="M12 5.2v13.6"
        stroke="currentColor"
        strokeWidth="1.45"
        strokeLinecap="round"
      />
      <circle
        cx="12"
        cy="12"
        r="2.35"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.45"
      />
      {/* Goals */}
      <path
        d="M3.4 9.15h2.15v5.7H3.4M20.6 9.15h-2.15v5.7H20.6"
        stroke="currentColor"
        strokeWidth="1.45"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const MARKS: Record<AudienceMarkKind, (props: MarkProps) => JSX.Element> = {
  community: CommunityMark,
  academy: AcademyMark,
  venue: VenueMark,
}

export function AudienceMark({
  kind,
  className = 'h-[22px] w-[22px]',
}: {
  kind: AudienceMarkKind
  className?: string
}) {
  const Mark = MARKS[kind]
  return <Mark className={className} />
}
